// extracted by mini-css-extract-plugin
module.exports = {"Counter":"Counter_Counter__3SCzp"};